// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23pbV","right":"styles_right__3_b58"};